import { ViewStyle, TextStyle } from "react-native"
import { color, nativeBaseTheme, spacing } from "../../theme"

/**
 * All text will start off looking like this.
 */
const BASE_VIEW: ViewStyle = {
  paddingVertical: spacing[2],
  paddingHorizontal: spacing[2],
  borderRadius: 4,
  justifyContent: "center",
  alignItems: "center",
}

const BASE_TEXT: TextStyle = {
  // paddingHorizontal: spacing[3],
}

/**
 * All the variations of text styling within the app.
 *
 * You want to customize these to whatever you need in your app.
 */
export const viewPresets = (colorScheme = "light") => ({
  /**
   * A smaller piece of secondard information.
   */
  primary: { ...BASE_VIEW, backgroundColor: colorScheme === "light" ? color.primary : nativeBaseTheme.colors.light["50"] } as ViewStyle,

  danger: { ...BASE_VIEW, backgroundColor: colorScheme === "light" ?  nativeBaseTheme.colors.danger["700"] : nativeBaseTheme.colors.danger["300"] } as ViewStyle,

  outline: { ...BASE_VIEW, paddingVertical: spacing[2] - 1, paddingHorizontal: spacing[2] - 1, borderWidth: 1, borderColor: colorScheme === "light" ? color.primary : nativeBaseTheme.colors.lightText } as ViewStyle,

  disabled: { ...BASE_VIEW, backgroundColor: color.palette.gray500 } as ViewStyle,

  loading: { ...BASE_VIEW, backgroundColor: colorScheme === "light" ? color.palette.blue300 : color.palette.blue700 } as ViewStyle,

  get primarySmall() {
    return { ...this.primary, paddingVertical: 7, paddingHorizontal: 8 }
  },

  /**
   * A button without extras.
   */
  link: {
    ...BASE_VIEW,
    paddingHorizontal: 0,
    paddingVertical: 0,
    alignItems: "flex-start",
  } as ViewStyle,
})

export const viewPresetsLight = viewPresets()

export const textPresets = (colorScheme = "light") => ({
  primary: { ...BASE_TEXT, color: colorScheme === "light" ? nativeBaseTheme.colors.lightText : nativeBaseTheme.colors.darkText } as TextStyle,
  danger: { ...BASE_TEXT, color: colorScheme === "light" ? nativeBaseTheme.colors.darkText : nativeBaseTheme.colors.lightText } as TextStyle,
  outline: { ...BASE_TEXT, color: colorScheme === "light" ? color.primary : nativeBaseTheme.colors.lightText } as TextStyle,
  link: {
    ...BASE_TEXT,
    color: colorScheme === "light" ? color.primary : nativeBaseTheme.colors.lightText,
    paddingHorizontal: 0,
    paddingVertical: 0,
  } as TextStyle,
  linkLoading: { ...BASE_TEXT, color: color.palette.gray500 }
})

/**
 * A list of preset names.
 */
export type ButtonPresetNames = keyof typeof viewPresetsLight
